// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"613":"2db3f484","2562":"b785fa00","4845":"2db3f484","6185":"cd72647e","6708":"6d32c6b7"}[chunkId] + ".chunk.css";
};